<template style="width: 100vw;height: 100vw;">
    <span v-if="popupName === 'default' || popupName === undefined">
        <div v-if="modalVisible" class="container-modal">
            <span class="modal-window" ref="my-modal" hide-footer>
                <div id="header_back" class="window-header" style="color:#fff;">
                <h3 style="padding-left: 20px;">{{header}}</h3>
                    <svg v-on:click="hideModal()" class="modal-cancel" width="22" height="22" viewBox="0 0 10 10" fill="#fff" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.71405 1.46482C10.0395 1.13939 10.0395 0.611747 9.71405 0.286311C9.38861 -0.0391261 8.86097 -0.0391262 8.53553 0.286311L5 3.82184L1.46447 0.286311C1.13903 -0.0391264 0.611392 -0.0391261 0.285955 0.286311C-0.0394817 0.611747 -0.0394818 1.13939 0.285955 1.46482L3.82149 5.00036L0.285955 8.53589C-0.0394817 8.86133 -0.0394821 9.38896 0.285955 9.7144C0.611392 10.0398 1.13903 10.0398 1.46447 9.7144L5 6.17887L8.53553 9.7144C8.86097 10.0398 9.38861 10.0398 9.71405 9.7144C10.0395 9.38896 10.0395 8.86133 9.71405 8.53589L6.17851 5.00036L9.71405 1.46482Z" fill="white"/>
                    </svg>
                </div>
                <div class="modal-info">{{info}}</div>
                <div class="modal-do">
                    <button class="ui-button ui-button--sm ui-button--secondary" block v-on:click="hideModal(buttonText)">{{ buttonText }}</button>
                    <button v-if="(buttonText2 !== undefined)" class="ui-button ui-button--sm ui-button--grey" block v-on:click="hideModal(buttonText2)">{{ buttonText2 }}</button>
                </div>
            </span>
        </div>
    </span>
    <span v-if="popupName === 'cancelOrderDis'">
        <div v-if="modalVisible" class="container-modal">
            <span class="modal-window" ref="my-modal" hide-footer>
                <div id="header_back" class="window-header" style="color:#fff;">
                <h3 style="padding-left: 20px;">{{header}}</h3>
                <!--<svg v-on:click="hideModal()" class="modal-cancel" width="22" height="22" viewBox="0 0 10 10" fill="#fff" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.71405 1.46482C10.0395 1.13939 10.0395 0.611747 9.71405 0.286311C9.38861 -0.0391261 8.86097 -0.0391262 8.53553 0.286311L5 3.82184L1.46447 0.286311C1.13903 -0.0391264 0.611392 -0.0391261 0.285955 0.286311C-0.0394817 0.611747 -0.0394818 1.13939 0.285955 1.46482L3.82149 5.00036L0.285955 8.53589C-0.0394817 8.86133 -0.0394821 9.38896 0.285955 9.7144C0.611392 10.0398 1.13903 10.0398 1.46447 9.7144L5 6.17887L8.53553 9.7144C8.86097 10.0398 9.38861 10.0398 9.71405 9.7144C10.0395 9.38896 10.0395 8.86133 9.71405 8.53589L6.17851 5.00036L9.71405 1.46482Z" fill="white"/>
                </svg>-->
                </div>
                <div class="modal-info" style="display: flex; flex-flow: column; justify-content: flex-start; align-items: flex-start;">
                    <span style="font-size: 18px; line-height: 24px; margin-top:25px; display: flex;">{{info}}</span>
                    <textarea type="" id="why_cancel_d_text" name="cancelComment" placeholder="Другое" class="forminput" style="margin-top:25px; border-radius: 0; padding-top: 15px; min-height:100%; width:90%; height: 104px;justify-content: flex-start !important; resize: none;"></textarea>
                    <div v-show="error_empty" style="color: red;font-size: 18px;">Укажите причину (нельзя оставлять поле пустым)</div>
                </div>
                <div class="modal-do">
                    <button v-if="(buttonText2 !== undefined)" style="background: #98A09F;" class="ui-button ui-button--sm ui-button--grey" block v-on:click="hideModal(buttonText2)">{{ buttonText2 }}</button>
                    <button class="ui-button ui-button--sm ui-button--secondary" block v-on:click="hideModal(buttonText)">{{ buttonText }}</button>
                </div>
            </span>
        </div>
    </span>
    <span v-if="popupName === 'cancelOrder'">
        <div v-if="modalVisible" class="container-modal">
            <span class="modal-window" ref="my-modal" hide-footer>
                <div id="header_back" class="window-header" style="color:#fff;">
                <h3 style="padding-left: 20px;">{{header}}</h3>
                <svg v-on:click="hideModal()" class="modal-cancel" width="22" height="22" viewBox="0 0 10 10" fill="#fff" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.71405 1.46482C10.0395 1.13939 10.0395 0.611747 9.71405 0.286311C9.38861 -0.0391261 8.86097 -0.0391262 8.53553 0.286311L5 3.82184L1.46447 0.286311C1.13903 -0.0391264 0.611392 -0.0391261 0.285955 0.286311C-0.0394817 0.611747 -0.0394818 1.13939 0.285955 1.46482L3.82149 5.00036L0.285955 8.53589C-0.0394817 8.86133 -0.0394821 9.38896 0.285955 9.7144C0.611392 10.0398 1.13903 10.0398 1.46447 9.7144L5 6.17887L8.53553 9.7144C8.86097 10.0398 9.38861 10.0398 9.71405 9.7144C10.0395 9.38896 10.0395 8.86133 9.71405 8.53589L6.17851 5.00036L9.71405 1.46482Z" fill="white"/>
                </svg>
                </div>
                <div class="modal-info" style="display: flex; flex-flow: column; justify-content: flex-start; align-items: flex-start;">
                    <span style="font-size: 18px; line-height: 24px; margin-top:25px; display: flex;">{{info}}</span>
                    <label class="checkbox" style="margin-top:25px; display: flex;">
                        <div class="check__container">
                            <input class="checkbox_radio_id" type="radio" id="why_cancel_1" name="cancel" value="1" checked>
                            <span class="checkmark"></span>
                        </div>
                        <a class="checkmark_text" style="color:#000; margin-left: 25px; font-size: 18px; line-height: 24px;" id="why_cancel_1_text">Изменились планы пациента</a>
                    </label>
                    <label class="checkbox" style="margin-top:25px; display: flex;">
                        <div class="check__container">
                            <input class="checkbox_radio_id" type="radio" id="why_cancel_2" name="cancel" value="2">
                            <span class="checkmark"></span>
                        </div>
                        <a class="checkmark_text" style="color:#000; margin-left: 25px; font-size: 18px; line-height: 24px;" id="why_cancel_2_text">Смена исполнителя-перевозчика</a>
                    </label>
                    <label class="checkbox" style="margin-top:25px; display: flex;" >
                        <div class="check__container">
                            <input class="checkbox_radio_id" type="radio" id="why_cancel_3" name="cancel" value="3">
                            <span class="checkmark"></span>
                        </div>
                        <a class="checkmark_text" style="color:#000; margin-left: 25px; font-size: 18px; line-height: 24px;" id="why_cancel_3_text">Пациент заболел</a>
                    </label>
                    <label class="checkbox" style="margin-top:25px; display: flex;" >
                        <div class="check__container">
                            <input class="checkbox_radio_id" type="radio" id="why_cancel_d" name="cancel" value="4">
                            <span class="checkmark"></span>
                        </div>
                        <a class="checkmark_text" style="color:#000; margin-left: 25px; font-size: 18px; line-height: 24px;">Другое</a>
                    </label>
                    <textarea type="" id="why_cancel_d_text" name="cancelComment" placeholder="Другое" class="forminput" style="display:none; margin-top:25px; border-radius: 0; padding-top: 15px; min-height:100%; width:90%; height: 104px;justify-content: flex-start !important; resize: none;"></textarea>
                </div>
                <div class="modal-do">
                    <button v-if="(buttonText2 !== undefined)" style="background: #98A09F;" class="ui-button ui-button--sm ui-button--grey" block v-on:click="hideModal(buttonText2)">{{ buttonText2 }}</button>
                    <button class="ui-button ui-button--sm ui-button--secondary" block v-on:click="hideModal(buttonText)">{{ buttonText }}</button>
                </div>
            </span>
        </div>
    </span>

    <span v-if="popupName === 'editingOrder'">
        <div v-if="modalVisible" class="container-modal">
            <span class="modal-window" ref="my-modal" hide-footer>
                <div id="header_back" class="window-header" style="color:#fff;">
                    <h3 style="padding-left: 20px;">{{header}}</h3>
                    <svg v-on:click="hideModal()" class="modal-cancel" width="22" height="22" viewBox="0 0 10 10" fill="#fff" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.71405 1.46482C10.0395 1.13939 10.0395 0.611747 9.71405 0.286311C9.38861 -0.0391261 8.86097 -0.0391262 8.53553 0.286311L5 3.82184L1.46447 0.286311C1.13903 -0.0391264 0.611392 -0.0391261 0.285955 0.286311C-0.0394817 0.611747 -0.0394818 1.13939 0.285955 1.46482L3.82149 5.00036L0.285955 8.53589C-0.0394817 8.86133 -0.0394821 9.38896 0.285955 9.7144C0.611392 10.0398 1.13903 10.0398 1.46447 9.7144L5 6.17887L8.53553 9.7144C8.86097 10.0398 9.38861 10.0398 9.71405 9.7144C10.0395 9.38896 10.0395 8.86133 9.71405 8.53589L6.17851 5.00036L9.71405 1.46482Z" fill="white"/>
                    </svg>
                </div>
                <div class="modal-info" style="display: flex; flex-flow: column; justify-content: flex-start; align-items: flex-start;">
                    <label>
                        <h4>Заказ</h4>
                        <span style="margin-left:15px; display: flex;"> 
                            Начало выполнение:&nbsp;
                            <editableText
                            :variableName="'date_start'"
                            :initialText="formatDateForEditableText(editing.date_start)"
                            @saved="changeData"></editableText>
                        </span>
                        <span style="margin-left:15px; display: flex;"> 
                            Цена:&nbsp;
                            <editableText
                            :variableName="'price'"
                            :initialText="editing.price"
                            @saved="changeData">{{ (editing.price != -1) ? "руб" : "" }}</editableText>
                        </span>
                    </label>
                    <label>
                        <h4>Контактное лицо</h4>
                        <span style="margin-left:15px; display: flex;"> 
                            Имя:&nbsp;
                            <editableText
                            :variableName="'contactName'"
                            :initialText="editing.contactName"
                            @saved="changeData"></editableText>
                        </span>
                        <span style="margin-left:15px; display: flex;"> 
                            Телефон:&nbsp;
                            <editableText
                            :variableName="'contactPhone'"
                            :initialText="editing.contactPhone"
                            @saved="changeData"></editableText>
                        </span>
                    </label>
                    <label>
                        <h4>Пациент</h4>
                        <span style="margin-left:15px; display: flex; align-items: center;"> 
                            <HoverIcon  style="padding-top: 8px; margin-right: 8px;">
                                <template v-slot:hoverText>
                                    <span style="font-weight:700;">Можно использовать только данные значения:</span><br><br>
                                    <span style="font-weight:700;">Удовлетворительное</span> - пациент в стабильном состоянии, сопровождение бригады врачей не требуется.<br><br>
                                    <span style="font-weight:700;">Средней тяжести</span> - пациент в стабильном состоянии, но при транспортировке может понадобиться медицинская помощь.<br><br>
                                    <span style="font-weight:700;">Крайне тяжелое</span> - пациент находится в критическом состоянии, транспортировка возможна только на реанимобиле в сопровождении медицинской бригады.<br>
                                </template>
                            </HoverIcon>
                            Состояние:&nbsp;
                            <editableText
                            :variableName="'state'"
                            :initialText="editing.state"
                            @saved="changeData"></editableText>
                        </span>
                        <span style="margin-left:15px; display: flex;"> 
                            <HoverIcon  style="padding-top: 8px; margin-right: 8px;">
                                <template v-slot:hoverText>
                                    <span style="font-weight:700;">Можно использовать только данные значения:</span><br><br>
                                    <span style="">1) Взрослый</span><br>
                                    <span style="">2) Ребенок</span>
                                </template>
                            </HoverIcon>
                            Возраст:&nbsp;
                            <editableText
                            :variableName="'age'"
                            :initialText="editing.age"
                            @saved="changeData"></editableText>
                        </span>
                        <span style="margin-left:15px; display: flex;"> 
                            Вес:&nbsp;
                            <editableText
                            :variableName="'weight'"
                            :initialText="editing.weight"
                            @saved="changeData"></editableText>
                        </span>
                        <span style="margin-left:15px; display: flex;"> 
                            Пол:&nbsp;
                            <editableText
                            :variableName="'gender'"
                            :initialText="editing.gender"
                            @saved="changeData"></editableText>
                        </span>
                        <span style="margin-left:15px; display: flex;">
                            Беременность:&nbsp;
                            <editableText
                            :variableName="'isPregnant'"
                            :initialText="editing.isPregnant"
                            @saved="changeData"></editableText>
                        </span>
                        <span style="margin-left:15px; display: flex;"> 
                            <HoverIcon  style="padding-top: 8px; margin-right: 8px;">
                                <template v-slot:hoverText>
                                    <span style="font-weight:700;">Можно использовать только данные значения:</span><br><br>
                                    <span style="font-weight:700;">Лежачий</span> - пациент который может находиться только в лежачем состоянии.<br><br>
                                    <span style="font-weight:700;">Лежачий, присаживается</span> - пациент который может присаживаться на некоторое время.<br><br>
                                    <span style="font-weight:700;">На кресле-коляске</span> - пациент который может передвигаться в кресле-коляске.<br><br>
                                    <span style="font-weight:700;">Передвигается самостоятельно</span> - пациент который передвегается полностью самостоятельно.<br>
                                </template>
                            </HoverIcon>
                            Мобильность:&nbsp;
                            <editableText
                            :variableName="'mobility'"
                            :initialText="editing.mobility"
                            @saved="changeData"></editableText>
                        </span>
                    </label>
                    <label>
                        <h4>Транспорт</h4>
                        <span style="margin-left:15px; display: flex;"> 
                            <HoverIcon  style="padding-top: 8px; margin-right: 8px;">
                                <template v-slot:hoverText>
                                    <span style="font-weight:700;">Можно использовать только данные значения:</span><br><br>
                                    <span style="font-weight:700;">авто</span> - перевозка с помощью автомобиля.<br><br>
                                    <span style="font-weight:700;">жд</span> - перевозка с помощью поезда.<br><br>
                                    <span style="font-weight:700;">самолет</span> - перевозка с помощью самолета.<br><br>
                                    <span style="font-weight:700;">водный</span> - перевозка с помощью водного транспорта.<br>
                                </template>
                            </HoverIcon>
                            Тип ТС:&nbsp;
                            <editableText
                            :variableName="'transport'"
                            :initialText="editing.transport"
                            @saved="changeData"></editableText>
                        </span>
                        <span style="margin-left:15px; display: flex;"> 
                            Ожидать на месте:&nbsp;
                            <editableText
                            :variableName="'isWait'"
                            :initialText="editing.isWait"
                            @saved="changeData"></editableText>
                        </span>
                        <span style="margin-left:15px; display: flex;"> 
                            Сколько ждать:&nbsp;
                            <editableText
                            :variableName="'nnWaitTime'"
                            :initialText="editing.nnWaitTime"
                            @saved="changeData"></editableText>
                        </span>
                        <span style="margin-left:15px; display: flex;"> 
                            В обратную сторону:&nbsp;
                            <editableText
                            :variableName="'isReturn'"
                            :initialText="editing.isReturn"
                            @saved="changeData"></editableText>
                        </span>
                    </label>
                    <label>
                        <h4>Комментарий</h4>
                        <editableText
                        :variableName="'comment'"
                        :initialText="editing.comment"
                        @saved="changeData"></editableText>
                    </label>
                </div>
                <div class="modal-do">
                    <button class="ui-button ui-button--sm ui-button--secondary" block v-on:click="hideModal(buttonText, editing)">{{ buttonText }}</button>
                    <button v-if="(buttonText2 !== undefined)" style="background: #98A09F;" class="ui-button ui-button--sm ui-button--grey" block v-on:click="hideModal(buttonText2)">{{ buttonText2 }}</button>
                </div>
            </span>
        </div>
    </span>
</template>
  
<script>
import editableText from './editableTextComponent.vue';
import $ from 'jquery';
import tools from '@/assets/js/tools.js';
import HoverIcon from './HoverInfoComponent.vue';

export default {
    name: 'PopupWindow',
    components: {
        editableText,
        HoverIcon
    },
    props: {
        popupName: String,
        header: String,
        info: String,
        buttonText: String,
        color: String,
        buttonText2: String,
        orderData: {
            type: Array,
            default: () => [],
        },
        callback: {
            type: Function,
            default() { return function(){} }
        },
    },
    data() {
        return {
            tools: tools,
            editing: this.orderData,
            modalVisible: true,
            error_empty: false,
        }
    },
    mounted() {
        $(".checkbox_radio_id").on("click", function () {
            if ($(this).is(":checked")) {
                if ($(this).attr('id') === 'why_cancel_d')  {
                    $('#why_cancel_d_text').css('display', 'flex')
                } else {
                    $('#why_cancel_d_text').css('display', 'none')
                }
            } 
        })
    },
    methods: {
        formatDateForEditableText(date) {
            if (typeof date === 'string') {
                return date
            } else {
                return tools.formatDate(new Date(date), 'hh:mm dd.MM.YYYY')
            }
        },
        changeData(value, varName) {
            if (varName in this.$data.editing) {
                this.$data.editing[varName] = value;
            } else {
                console.error(`Variable with name ${varName} does not exist in data.`);
            }
        },
        hideModal(button, data) {
            var whyText = "";
            if (this.popupName == 'cancelOrder') {
                var optionIds = ["why_cancel_1", "why_cancel_2", "why_cancel_3", "why_cancel_d"]
                for (var x of optionIds) {
                    if (document.getElementById(x).checked) {
                        whyText = document.getElementById(x + "_text").innerText
                        if (whyText == "") whyText = document.getElementById(x + "_text").value
                    }
                }
            }
            if (this.popupName == "cancelOrderDis") {
                whyText = document.getElementById("why_cancel_d_text").value
                if (button == "Да" && whyText.length == 0) {
                    this.error_empty = true
                    return
                }
            }
            this.modalVisible = false;
            if (this.callback) this.callback(button, whyText, data)
        },
    }
}
</script>

<style lang="css" scoped src="@/assets/css/modal.css"></style>
<style lang="css" scoped src='@/assets/css/dispatcher_orders.css'></style>
